<template>
  <div>
    <!-- 内容区 -->
    <div class="content">
      <div class="w">
        <table class="car_pic">
          <thead>
            <tr>
              <th class=" car_info">
                <div class="car_text">基本信息</div>
              </th>
              <th class="car" v-if="contrastPicList[0]">
                <img v-if="contrastPicList[0]" :src="contrastPicList[0].coverUrl" alt="" />
                <i class="el-icon-circle-close" @click="deleteCar(contrastIdList[0])"></i>
                <div>{{ contrastPicList[0].vehicleName }}</div>
              </th>
              <th class="car" v-else>
                <img src="../assets/img/default.png" alt="" />
                <div @click="toBuyCar">选择车辆</div>
              </th>
              <th class="car" v-if="contrastPicList[1]">
                <img v-if="contrastPicList[1]" :src="contrastPicList[1].coverUrl" alt="" />
                <i class="el-icon-circle-close" @click="deleteCar(contrastIdList[1])"></i>
                <div>{{ contrastPicList[1].vehicleName }}</div>
              </th>
              <th class="car" v-else>
                <img src="../assets/img/default.png" alt="" />
                <div @click="toBuyCar">选择车辆</div>
              </th>
              <th class="car" v-if="contrastPicList[2]">
                <img v-if="contrastPicList[2]" :src="contrastPicList[2].coverUrl" alt="" />
                <i class="el-icon-circle-close" @click="deleteCar(contrastIdList[2])"></i>
                <div>{{ contrastPicList[2].vehicleName }}</div>
              </th>
              <th class="car" v-else>
                <img src="../assets/img/default.png" alt="" />
                <div @click="toBuyCar">选择车辆</div>
              </th>
              <th class="car" v-if="contrastPicList[3]">
                <img v-if="contrastPicList[3]" :src="contrastPicList[3].coverUrl" alt="" />
                <i class="el-icon-circle-close" @click="deleteCar(contrastIdList[3])"></i>
                <div>{{ contrastPicList[3].vehicleName }}</div>
              </th>
              <th class="car" v-else>
                <img src="../assets/img/default.png" alt="" />
                <div @click="toBuyCar">选择车辆</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>售价</td>
              <td v-if="contrastPicList[0]">{{ contrastPicList[0].showPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[1]">{{ contrastPicList[1].showPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[2]">{{ contrastPicList[2].showPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[3]">{{ contrastPicList[0].showPrice }}万元</td>
              <td v-else>-</td>
            </tr>
            <tr>
              <td>新车价</td>
              <td v-if="contrastPicList[0]">{{ contrastPicList[0].newcarPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[1]">{{ contrastPicList[1].newcarPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[2]">{{ contrastPicList[2].newcarPrice }}万元</td>
              <td v-else>-</td>
              <td v-if="contrastPicList[3]">{{ contrastPicList[0].newcarPrice }}万元</td>
              <td v-else>-</td>
            </tr>
          </tbody>
        </table>
        <table v-for="(item, index) in contrastList" :key="index">
          <tbody>
            <tr>
              <td colspan="5" class="title">{{ item.title }}</td>
            </tr>
            <tr v-for="(v, i) in item.children" :key="i">
              <td>{{ v.subTitle }}</td>
              <td v-for="(vv, ii) in v.subValues" :key="ii">{{ vv }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import menus from '../utils/menu'
export default {
  data() {
    return {
      contrastIdList: [],
      contrastList: [],
      contrastPicList: []
    }
  },
  created() {
    var menuActive = this.$route.name
    if (menuActive == this.$store.state.menuActive) {
    } else {
      var keys = Object.keys(menus)
      if (keys.findIndex(item => item == menuActive) != -1) {
        this.$store.commit('setMenuActive', menuActive)
      }
    }

    var contrastIdList = JSON.parse(window.sessionStorage.getItem('contrastIdList'))
    if (contrastIdList) {
      this.contrastIdList = contrastIdList
    }
    // 获取车辆对比和信息列表
    this.getContrastList()
    this.getContrastPicList()
  },
  mounted() {},
  methods: {
    async getContrastList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleKindPkTrim?tradeIds=' + this.contrastIdList.join(','))
      if (data.success) {
        this.contrastList = data.data.page
      }
    },
    async getContrastPicList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehiclePkTrim?tradeIds=' + this.contrastIdList.join(','))
      if (data.success) {
        this.contrastPicList = data.data.page
      }
    },
    toBuyCar() {
      this.$router.push({
        path: '/buy-car'
      })
    },
    deleteCar(id) {
      var index = this.contrastIdList.findIndex(item => item == id)
      this.contrastIdList.splice(index, 1)
      window.sessionStorage.setItem('contrastIdList', JSON.stringify(this.contrastIdList))
      // 获取车辆对比和信息列表
      this.getContrastList()
      this.getContrastPicList()
    }
  },
  watch: {},
  computed: {}
}
</script>

<style lang="less" scoped>
.nav_bar {
  background-color: #f5f5f5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content {
  margin: 40px 0;
}
.car_pic {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #fff;
}
table,
thead,
tbody {
  width: 100%;
  border: 1px solid #f2f2f2;
  border-collapse: collapse;
}
tr,
td,
th {
  border: 1px solid #eaeaea;
}

.car {
  position: relative;
  width: 20%;
  height: 200px;
  i {
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
  }
  img {
    width: 75%;
    height: 60%;
    object-fit: cover;
  }
  div {
    margin-top: 10px;
    height: 40px;
    font-size: 14px;
    padding: 0 5px;
    font-weight: normal;
    cursor: pointer;
  }
}
tr {
  td {
    padding: 10px;
    width: 20%;
  }
  & td:nth-of-type(1) {
    text-align: right;
  }
  .title {
    background-color: #f2f2f2;
    text-align: left !important;
  }
}
.car_info {
  width: 20%;
  height: 200px;
  position: relative;
  .car_text {
    position: absolute;
    top: 20px;
    left: 20px;
    color: #ff8300;
    font-size: 20px;
    font-weight: 700;
  }
}
</style>
